const LOCATIONS = [
  { label: 'New York',       lon: '-74.01', lat: '40.71',  utcOffset: -5,   tz: 'EST' },
  { label: 'Chicago',        lon: '-87.63', lat: '41.88',  utcOffset: -6,   tz: 'CST' },
  { label: 'London',         lon: '-0.12',  lat: '51.51',  utcOffset: 0,    tz: 'GMT' },
  { label: 'Mumbai',         lon: '72.88',  lat: '19.08',  utcOffset: 5.5,  tz: 'IST' },
  { label: 'San Francisco',  lon: '-122.42', lat: '37.77', utcOffset: -8,   tz: 'PST' },
];

export default LOCATIONS;
